import React from 'react';

import { Col, Row } from 'antd';

import { CreditsPoolOverview, ICreditsPoolOverview } from '../CreditsPoolOverview';

type Props = {
  creditsPools: ICreditsPoolOverview[];
};

const CreditsPoolsDashboardWithDataBase: React.FC<Props> = ({ creditsPools }) => {
  return(
    <Row gutter={[24, 24]}>
      {creditsPools.map((creditsPool) => {
        return (
          <Col
            key={creditsPool.id}
            xs={24}
            lg={12}
            xxl={8}
          >
            <CreditsPoolOverview
              id={creditsPool.id}
              credits={creditsPool.credits}
              name={creditsPool.name}
              users={creditsPool.users}
              pending={creditsPool.pending}
              finalized={creditsPool.finalized}
              thresholdWarningMessage={creditsPool.thresholdWarningMessage}
            />
          </Col>
        );
      })}
    </Row>
  );
};

const CreditsPoolsDashboardWithData = React.memo(CreditsPoolsDashboardWithDataBase);

export { CreditsPoolsDashboardWithData };
